import React from 'react';
import { Box, Typography } from '@mui/material';
import { getSlotStyle } from './constants';

const ReservedSlotRow = ({ slot, onUpdateSlotStatus }) => {
  const style = getSlotStyle(slot.status);

  return (
    <Box
      sx={{
        p: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: '#FFFFFF',
        borderRadius: 2,
        borderLeft: `4px solid ${style.color}`,
        boxShadow: '0px 2px 4px rgba(0,0,0,0.02)',
      }}
    >
      {/* TIME */}
      <Typography variant="caption" fontWeight={700}>
        {new Date(slot.start_time.replace(' ', 'T')).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })}
        <span style={{ color: '#A3AED0', margin: '0 8px' }}>→</span>
        {new Date(slot.end_time.replace(' ', 'T')).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })}
      </Typography>

      {/* STATUS + ACTION */}
      <Box display="flex" alignItems="center" gap={1}>
        {/* badge status */}
        <Box
          sx={{
            px: 1,
            py: 0.3,
            borderRadius: 2,
            fontSize: 11,
            fontWeight: 700,
            bgcolor: style.bg,
            color: style.color,
            textTransform: 'capitalize',
          }}
        >
          {slot.status}
        </Box>

        {/* select update */}
        <select
          value={slot.status}
          onChange={(e) => onUpdateSlotStatus(slot.id_reserved_slot, e.target.value)}
          style={{
            fontSize: 12,
            padding: '4px 6px',
            borderRadius: 6,
            border: '1px solid #E2E8F0',
            cursor: 'pointer',
            outline: 'none',
          }}
        >
          <option value="available">Disponible</option>
          <option value="reserved">Réservé</option>
          <option value="blocked">Bloqué</option>
          <option value="cancelled">Annulé</option>
        </select>
      </Box>
    </Box>
  );
};

export default ReservedSlotRow;
